import {isWorkMetadataValue} from 'services/utils/functions/isWorkMetadataValue';
import {isWorkWithExpressions} from 'services/utils/functions/isWorkWithExpressions';
import type {
  ManifestationV4,
  WorkMetadata,
  WorkWithExpressions,
} from '../types';

export const findManifestation = (
  work: WorkWithExpressions | WorkMetadata,
  manifestationId: string | undefined,
): ManifestationV4 | undefined => {
  if (isWorkWithExpressions(work)) {
    return findManifestationInWorkWithExpressions(work, manifestationId);
  }
  if (isWorkMetadataValue(work)) {
    return findManifestationInWorkMetadata(work, manifestationId);
  }

  return undefined;
};

export const findManifestationInWorkWithExpressions = (
  work: WorkWithExpressions,
  manifestationId: string | undefined,
): ManifestationV4 | undefined => {
  return manifestationId
    ? (work.expressions ?? [])
        .map(e => e.manifestations)
        .flat()
        .find(m => m.id === manifestationId)
    : undefined;
};

export const findManifestationInWorkMetadata = (
  work: WorkMetadata,
  manifestationId: string | undefined,
): ManifestationV4 | undefined => {
  return manifestationId
    ? (work.manifestations ?? []).find(m => m.id === manifestationId)
    : undefined;
};
